import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EstadoRequisicao } from 'store/types';
import { UnidadesUFCAction } from 'store/UnidadesUFC/UnidadesUFC.action';
import { UnidadesUFCSelector } from 'store/UnidadesUFC/UnidadesUFC.selector';
import { AlertaInline } from '../AlertaInline/AlertaInline';
import { CascaderField, CascaderProps } from "view/component/CascaderField/CascaderField";


export const UnidadesUFCCascader: FC<CascaderProps> = (props) => {
  const dispatch = useDispatch();
  
  const estado = useSelector(UnidadesUFCSelector.estado);
  const erros = useSelector(UnidadesUFCSelector.erros);
  const isCarregando = estado !== EstadoRequisicao.BEM_SUCEDIDO;
  const floresta = useSelector(UnidadesUFCSelector.cascade());

  useEffect(() => {
    if (estado === EstadoRequisicao.OCIOSO) {
      dispatch(UnidadesUFCAction.carregar());
    }
  }, [estado, dispatch]);
  
  return <>
    <CascaderField
      {...props}
      isLoading={isCarregando}
      disabled={isCarregando}
      placeholder="Selecione uma unidade ou deixe vazio para 'REITORIA'"
      floresta={floresta ?? []}
    /> 
    { erros && <AlertaInline mensagem={erros.data?.message} /> }
  </>
}
